const InteractionsActionTypes = {
    ADD_INTERACTION: "ADD_INTERACTION",
    ADD_INTERACTIONS: "ADD_INTERACTIONS",
};

export default InteractionsActionTypes;